import {AnySlot} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {EMPTY_SLOT_FORMULA, SlotFormula} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {area, mk} from '@mintdata/mint-kit/api/log/mk';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {serialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export class SlotUtil
{
    public static isIValue(object:any):boolean
    {
        return Type.isInstanceOfIValue(object);
    }

    public static toJson(slot:AnySlot):any
    {
        return {
            id: slot.id,
            location: serialize(slot.location),
            formula: slot.formula
        };
    }

    // public static fromJson(json: Slot, sheetId: SheetId): Slot
    // {
    //
    //     return new Slot(json.id,
    //                     sheetId,
    //                     SlotUtil.ensureValidFormula(json.formula),
    //                     json.location);
    // }

    public static getIntegerValue(slot:AnySlot):number
    {
        const value = slot.value;

        if( !value )
            return null;

        if( Type.isInstanceOf(value, Type.Integer) )
            return (value as AInteger).value;

        return null;
    }

    public static getDecimalValue(slot:AnySlot):number
    {
        const value = slot.value;

        if( !value )
            return null;

        if( Type.isInstanceOf(value, Type.Number) )
            return (value as ANumber).value;

        return null;
    }

    public static ensureValidFormula(formula:SlotFormula):SlotFormula
    {
        return SlotUtil.isFormulaInvalid(formula) ? EMPTY_SLOT_FORMULA : formula;
    }

    public static isFormulaInvalid(formula:SlotFormula):boolean
    {
        if( formula === null || formula === undefined )
        {
            mk.error(area.Slot, `setFormula(): formula is null/undefined`);
            return true;
        }

        return false;
    }

    public static isFormula(formula:SlotFormula):boolean
    {
        return formula
            && typeof formula === 'string'
            && (formula.startsWith('=') || formula.startsWith('+='));
    }
}
